// extracted by mini-css-extract-plugin
export default {"comingsoon":"ComingSoon_comingsoon__nBQEz","container":"ComingSoon_container__XSpLO"};